import { Lead, LoanStage } from '../types'

export const STAGES: LoanStage[] = [
  'Lead Received',
  'Contact Made',
  'Application Taken',
  'Waiting on Documentation',
  'Docs Received',
  'Pre-Approved',
  'Accepted Offer',
  'Need Disclosure',
]

export const mockLeads: Lead[] = [
  {
    id: 'L-1001',
    firstName: 'Michael',
    lastName: 'Scott',
    leadDate: '2023-10-01',
    applicationDate: '2023-10-05',
    stage: 'Accepted Offer',
    pipelineStage: 'Pre-Approved',
    daysInStage: 2,
    referralSourceName: 'Dwight Schrute (Realtor)',
    referralSourceContact: 'dwight@schrutefarms.com',
    loanType: 'Purchase',
    loanProgram: 'Conventional',
    purchasePrice: 450000,
    ltv: 80,
    loanAmount: 360000,
    loanTerm: 30,
    subjectProperty: '123 Paper St, Scranton, PA',
    ficoScore: 740,
    lastContactDate: '2023-10-24',
    nextAction: 'Send initial disclosures',
  },
  {
    id: 'L-1002',
    firstName: 'Pam',
    lastName: 'Beesly',
    leadDate: '2023-10-15',
    applicationDate: null,
    stage: 'Contact Made',
    pipelineStage: 'Started',
    daysInStage: 5,
    referralSourceName: 'Zillow',
    referralSourceContact: 'N/A',
    loanType: 'Purchase',
    loanProgram: 'FHA',
    purchasePrice: 300000,
    ltv: 96.5,
    loanAmount: 289500,
    loanTerm: 30,
    subjectProperty: 'TBD',
    ficoScore: 680,
    lastContactDate: '2023-10-20',
    nextAction: 'Follow up for application',
  },
  {
    id: 'L-1003',
    firstName: 'Jim',
    lastName: 'Halpert',
    leadDate: '2023-09-20',
    applicationDate: '2023-09-22',
    stage: 'Waiting on Documentation',
    pipelineStage: 'Qualification',
    daysInStage: 14,
    referralSourceName: 'Phyllis Vance (Realtor)',
    referralSourceContact: 'phyllis@vancerealty.com',
    loanType: 'Refinance',
    loanProgram: 'Conventional',
    purchasePrice: null,
    ltv: 75,
    loanAmount: 400000,
    loanTerm: 15,
    subjectProperty: '456 Art Ave, Philadelphia, PA',
    ficoScore: 780,
    lastContactDate: '2023-10-10',
    nextAction: 'Call regarding missing W2s',
  },
  {
    id: 'L-1004',
    firstName: 'Stanley',
    lastName: 'Hudson',
    leadDate: '2023-10-22',
    applicationDate: '2023-10-23',
    stage: 'Docs Received',
    pipelineStage: 'Qualification',
    daysInStage: 1,
    referralSourceName: 'Past Client',
    referralSourceContact: 'N/A',
    loanType: 'Purchase',
    loanProgram: 'VA',
    purchasePrice: 550000,
    ltv: 100,
    loanAmount: 550000,
    loanTerm: 30,
    subjectProperty: '789 Florida St, Cape Coral, FL',
    ficoScore: 710,
    lastContactDate: '2023-10-23',
    nextAction: 'Submit to underwriting',
  },
  {
    id: 'L-1005',
    firstName: 'Angela',
    lastName: 'Martin',
    leadDate: '2023-10-25',
    applicationDate: null,
    stage: 'Lead Received',
    pipelineStage: 'Started',
    daysInStage: 1,
    referralSourceName: 'Bank Website',
    referralSourceContact: 'N/A',
    loanType: 'Purchase',
    loanProgram: 'Conventional',
    purchasePrice: 200000,
    ltv: 80,
    loanAmount: 160000,
    loanTerm: 30,
    subjectProperty: 'TBD',
    ficoScore: 790,
    lastContactDate: '2023-10-25',
    nextAction: 'Initial outreach call',
  },
  {
    id: 'L-1006',
    firstName: 'Kevin',
    lastName: 'Malone',
    leadDate: '2023-08-10',
    applicationDate: '2023-08-15',
    stage: 'Need Disclosure',
    pipelineStage: 'Pre-Approved',
    daysInStage: 3,
    referralSourceName: 'Oscar Martinez (CPA)',
    referralSourceContact: 'oscar@accounting.com',
    loanType: 'Purchase',
    loanProgram: 'FHA',
    purchasePrice: 250000,
    ltv: 96.5,
    loanAmount: 241250,
    loanTerm: 30,
    subjectProperty: '321 Chili Ln, Scranton, PA',
    ficoScore: 640,
    lastContactDate: '2023-10-22',
    nextAction: 'Clear to close prep',
  },
  {
    id: 'L-1007',
    firstName: 'Kelly',
    lastName: 'Kapoor',
    leadDate: '2023-09-05',
    applicationDate: '2023-09-10',
    stage: 'Pre-Approved',
    pipelineStage: 'Pre-Approved',
    daysInStage: 25,
    referralSourceName: 'Ryan Howard',
    referralSourceContact: 'ryan@wupfh.com',
    loanType: 'Purchase',
    loanProgram: 'Jumbo',
    purchasePrice: 1200000,
    ltv: 80,
    loanAmount: 960000,
    loanTerm: 30,
    subjectProperty: 'TBD',
    ficoScore: 760,
    lastContactDate: '2023-10-15',
    nextAction: 'Check in on house hunting',
  },
  {
    id: 'L-1008',
    firstName: 'Toby',
    lastName: 'Flenderson',
    leadDate: '2023-10-18',
    applicationDate: '2023-10-19',
    stage: 'Application Taken',
    pipelineStage: 'Started',
    daysInStage: 7,
    referralSourceName: 'HR Portal',
    referralSourceContact: 'N/A',
    loanType: 'Refinance',
    loanProgram: 'Conventional',
    purchasePrice: null,
    ltv: 60,
    loanAmount: 150000,
    loanTerm: 15,
    subjectProperty: '999 Sad St, Costa Rica',
    ficoScore: 800,
    lastContactDate: '2023-10-19',
    nextAction: 'Send needs list',
  },
]
